import React, { Component } from 'react'
import BootstrapTable from 'react-bootstrap-table-next';
import axios from 'axios';
import paginationFactory, {
    PaginationProvider,
    PaginationListStandalone
} from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import '../../Asset/Css/util.css';
import '../../Asset/Css/main.css';
import { Link } from 'react-router-dom';
import global from '../global';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { config } from '../../Constants';
import download from 'downloadjs';
import { Layout } from '../Layout';
import Spinner from '../Spinner';
import ReactNotification from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css'
import { store } from 'react-notifications-component';
import { Row, Col, InputGroup, FormControl } from 'react-bootstrap';
import {
    Card,
    Alert,
    CardBody,
    NavItem,
    NavLink,
    Nav,
    TabContent,
    TabPane, Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";
const { SearchBar } = Search;
const expandRow = {
    renderer: row => (
        <div>
            <p className="m-t-10">{`DP ID: ${row.NAME_CSV}`}</p>
        </div>
    ),
    showExpandColumn: true,
    expandByColumnOnly: true
};


export class FormGrid extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showMultipleDPodal: false,
            AssignmentCode: '',
            assignments: [],
            RemitterCode: '',
            DPList: '',
            url: '',
            columns: [{
                dataField: 'AssignmentCode',
                text: 'Assignment Code',
                hidden: true
            },
            {
                dataField: 'RemitterName',
                text: 'Remitter',
                headerAlign: 'center',
                sort: true,

                },
                {
                    dataField: 'EmailID',
                    text: 'Email',
                    headerAlign: 'center',
                    sort: true,

                },
                {
                    dataField: 'PAN',
                    text: 'PAN',
                    headerAlign: 'center',
                    sort: true,

                },
                {
                    dataField: 'DPID',
                    text: 'DP ID',
                    headerAlign: 'center',
                    sort: true,

                },
                
            {
                dataField: 'FinancialYear',
                text: 'Financial Year',
                headerAlign: 'center',
                align: 'center',
                sort: true,
                },
                {
                    dataField: 'AssignmentDate',
                    text: 'Assignment Date',
                    headerAlign: 'center',
                    align: 'center',
                    sort: true,
                },
            {
                dataField: "Fill",
                text: "Fill Form",
                headerAlign: 'center',
                align: 'center',
                formatter: (rowContent, row) => {
                    return (
                        <div>
                            <button className="btn btn-primary p-10"
                                onClick={e => {
                                    e.persist();

                                    if (row.DPID.includes("Multiple DPID")) {
                                        this.setState({
                                            showMultipleDPodal: true,
                                            AssignmentCode: row.AssignmentCode,
                                            DPList: row.NAME_CSV
                                        });
                                    }
                                    else {
                                        FormGrid.handleEdit(row.AssignmentCode, row.PAN, this.state.url)
                                    }

                                    //FormGrid.handleEdit(row.AssignmentCode, row.PAN, this.state.url)
                                }}> <FontAwesomeIcon icon="pencil-alt" /> </button>
                        </div>
                    )
                }
            },
            ],
            loading: false
        }
    }

    componentDidMount() {

        axios.get(global.UserManagement.GetSessionDetailsAPI)
            .then(response => {
                if (response.data.Status) {
                    this.setState({
                        RemitterCode: response.data.RemitterCode,
                        url: config.url.Web_URL + '/' + response.data.RemitterCode
                    });
                } else {
                    window.location.href = config.url.Web_URL + `/Error/404`;
                    return;
                }
            })
            .catch(error => {
                console.log(error);
            });


        axios.get(global.Form15GH.GetForm15GHDeclarationDetailsAPI +'?Type=P',
            { headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` } },
            { responseType: 'json' })
            .then(response => {
                if (response.data.status) {
                    this.setState({
                        assignments: response.data.Form15GHDetails
                    });
                }
                else {
                    this.setState({
                        assignments: []
                    });
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    static handleEdit(rowContent, PAN, URL) {

        window.location.href = URL + `/Form15GH` + '?AID=' + window.btoa(rowContent);
    }

    showNoti(title, message, type) {

        store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 10000,
                onScreen: true
            }
        });

    };

    modalCloseSave() {
        window.location.href = this.state.url + `/Form15GH` + '?AID=' + window.btoa(this.state.AssignmentCode);
    }

    modalCancel() {
        this.setState({
            showMultipleDPodal: false
        });
    };

    render() {
        if (this.state.loading) return <Spinner />;
        let contentFooter = Layout.RenderFooter();
        const options = {
            custom: true,
            paginationSize: 4,
            pageStartIndex: 1,
            firstPageText: 'First',
            prePageText: 'Back',
            nextPageText: 'Next',
            lastPageText: 'Last',
            nextPageTitle: 'First page',
            prePageTitle: 'Pre page',
            firstPageTitle: 'Next page',
            lastPageTitle: 'Last page',
            showTotal: true,
            totalSize: this.state.assignments.length
        };

        const contentTable = ({ paginationProps, paginationTableProps }) => (
            <div>
                <ToolkitProvider
                    keyField="AssignmentCode"
                    columns={this.state.columns}
                    data={this.state.assignments}
                    search
                >
                    {
                        toolkitprops => (
                            <div>
                                <BootstrapTable
                                    hover
                                    {...toolkitprops.baseProps}
                                    {...paginationTableProps}
                                    wrapperClasses="table-responsive"
                                    expandRow={expandRow} />
                            </div>
                        )
                    }
                </ToolkitProvider>
                <PaginationListStandalone {...paginationProps} />
            </div>
        );
        let content = Layout.RenderNavMenu()
        var url = config.url.API_URL;

        return (
            <div>
                <ReactNotification />
                {content}
                <Modal isOpen={this.state.showMultipleDPodal} size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered>
                    <ModalBody>
                        <Row>
                            <Col md={12} className="session-modal-text">
                                It appears that you have multiple demat accounts. However, you can fill a single declaration in Form 15G / 15H for all the below mentioned demat accounts<br /><br />
                                {`DP ID: ${this.state.DPList}`}
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-dark m-l-10" type="button" onClick={e => this.modalCancel(e)}>Cancel</button>
                        <button className="btn btn-primary m-l-10" type="button" onClick={e => this.modalCloseSave(e)}>Continue</button>
                    </ModalFooter>
                </Modal>
                <div className="Nexdigm">
                    <ol className="breadcrumb btn-Nexdigm">
                        <li><a href={this.state.url + "/Dashboard?UT=" + window.btoa(this.state.RemitterCode.toUpperCase() == "NEXDIGM" ? "A" : "U")} className="text-white"><FontAwesomeIcon icon="home" /> Home</a></li>
                        <li><a className="text-white">Form 15 G/H Declaration</a></li>
                    </ol>
                </div>
                <div className="content-page">
                    <div className="card">
                        <div className="card-body">
                            <h4 className="header-title m-b-10 ">Form 15 G/H Pending Declaration </h4>
                            
                            <PaginationProvider
                                pagination={
                                    paginationFactory(options)
                                }
                            >
                                {contentTable}
                            </PaginationProvider>

                        </div>
                    </div>
                </div>
                {contentFooter}
            </div>
        );
    }
}
